import {
  HANDLE_SCALE_MAX,
  HANDLE_SCALE_MIN,
  ROUND_HANDLE_RADIUS_PX,
  SQUARE_HANDLE_SIZE_PX,
} from './handleTokens';

/**
 * `scale` is viewBox units per screen pixel, so larger means zoomed out. Multiplying a
 * pixel value by it converts that value into user units.
 *
 * Handle geometry needs one of two behaviours, and which one a call site wants has to
 * be explicit — the two differ only at the extremes of the zoom range, which is
 * exactly where handles become unusable if the wrong one is picked.
 */

export const getCappedHandleScale = (scale: number) =>
  Math.min(HANDLE_SCALE_MAX, Math.max(HANDLE_SCALE_MIN, scale));

/**
 * A pixel value that holds a constant size on screen. Clamped, so handles stop
 * shrinking when fully zoomed in and stop growing when fully zoomed out.
 * Use for anything the user aims at or reads: handles, buttons, hit areas, labels.
 */
export const screenPx = (px: number, scale: number) =>
  px * getCappedHandleScale(scale);

/**
 * The same conversion without the clamp: still a constant size on screen, but it keeps
 * shrinking and growing past the ends of the handle range. Use it where a value should
 * track the viewport exactly rather than stay grabbable — snap guides, hairlines.
 */
export const worldPx = (px: number, scale: number) => px * scale;

export const getSquareHandleSize = (scale: number) =>
  screenPx(SQUARE_HANDLE_SIZE_PX, scale);

export const getRoundHandleRadius = (scale: number) =>
  screenPx(ROUND_HANDLE_RADIUS_PX, scale);
